import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const carousels = document.querySelectorAll('.testimonials__swiper');

  carousels.forEach((el) => {
    const root = el.closest('.testimonials');

    if (!root) {
      return;
    }

    const nav = root.querySelector('.testimonials__nav');
    const a11y = { enabled: true };

    if (nav) {
      a11y.prevSlideMessage = nav.dataset.prevLabel;
      a11y.nextSlideMessage = nav.dataset.nextLabel;
    }

    new Swiper(el, {
      modules: [Pagination],
      slidesPerView: 1,
      loop: false,
      watchOverflow: true,
      autoHeight: true,
      keyboard: { enabled: true },
      a11y,
      navigation: {
        prevEl: root.querySelector('.testimonials__prev'),
        nextEl: root.querySelector('.testimonials__next'),
      },
      pagination: {
        el: root.querySelector('.testimonials__fraction'),
        type: 'fraction',
        renderFraction(currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
        },
      },
    });
  });
});
